import styled from 'styled-components'

import { Alert, ResponsiveImage, TypeStyle, fromLg } from '@syconium/little-miss-figgy'

export const HeroWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  ${fromLg} {
    flex-direction: row;
  }
`

export const HeroImageWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
`

export const ResponsiveHeroImage = styled(ResponsiveImage)`
  display: block;
  height: auto;
  object-fit: cover;
  width: 100%;

  ${fromLg} {
    max-height: 560px;
  }
`

export const HeroContent = styled.div`
  display: flex;
  flex: 1;
`

export const HeroContentInner = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: ${o => o.theme.spacing(10)};
  padding-left: ${o => o.theme.spacing(4)};
  padding-right: ${o => o.theme.spacing(4)};
  ${fromLg} {
    padding-left: ${o => o.theme.spacing(30)};
    padding-right: ${o => o.theme.spacing(30)};
  }
`

export const Description = styled(TypeStyle.BodyDefault).attrs({ asTag: 'p' })`
  padding-bottom: ${o => o.theme.spacing(6)};
  text-align: center;
`

export const Title = styled(TypeStyle.HeadlineMedium).attrs({ asTag: 'h1' })`
  padding-bottom: ${o => o.theme.spacing(4)};
  text-align: center;
  text-transform: uppercase;
  line-height: 28px;
  letter-spacing: 3px;

  ${fromLg} {
    letter-spacing: 5.4px;
    line-height: 48px;
  }
`

export const DownloadWrapper = styled.a`
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  padding-bottom: ${o => o.theme.spacing(8)};
`

export const DownloadText = styled(TypeStyle.Eyebrow).attrs({ asTag: 'span' })`
  display: inline-block;
  font-size: ${o => o.theme.typography.font.size[13]};
  text-align: center;
  text-transform: uppercase;
  &::after {
    background: black;
    content: '';
    display: block;
    height: 2px;
    position: relative;
    top: 3px;
  }
`
export const BulkAlert = styled(Alert)`
  max-width: 100%;
`
export const BulkAlertMessage = styled(Alert.Message)`
  margin-top: -3px;
  font-size: ${o => o.theme.typography.font.size[13]};
  font-weight: ${o => o.theme.typography.font.weight[400]};
`
